module.exports = "<div class=\"footer-navbar navbar navbar-inverse navbar-fixed-bottom\" ng-if=\"$ctrl.show\"\n  style=\"min-height:10px !important;\">\n  <p style=\"margin:5px 0px; font-size:0.8em;\">\n    <a href=\"https://www.adagp.fr/\" target=\"_blank\"> Adagp</a> |\n    <a href=\"/contact\"> Contact</a> |\n    <a href=\"/legal\" translate> Mentions légales</a> |\n    <span style=\"color: black;\">Conception et développement : Adagp</span>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 173
// module chunks = 0